import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import { Name } from '../name'

/**
 * Disposes dynamic Organization EC instances
 */
export const onDispose = store.effects.create((feature: Feature) =>
  feature.actions.dispose.observe().pipe(
    rxjs.switchMap(
      ({ data: { entityId } }) =>
        ec.Collection.instances.find(
          entityId
            ? {
                names: [Name.from(entityId), Name.All.from(entityId)],
              }
            : {
                isName: TypeChecker.Factory.union(Name.isName, Name.All.isAll),
              },
        ).asObservable,
    ),
    rxjs.map(existingEcs => {
      for (const organizationEc of existingEcs) {
        organizationEc.destroy('SpaceOrganizations.Registry.Dispose')
      }
      return store.effects.SKIP
    }),
  ),
)
